import React from "react";

import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import ActivityStatus from "@mapmycustomers/shared/enum/activity/ActivityStatus";
import { Activity } from "@mapmycustomers/shared/types/entity";

import colors from "@app/styles/_colors.module.scss";
import getActivityStatus from "@app/util/activity/getActivityStatus";
import getBadgeImage from "@app/util/badge/getBadgeImage";
import { getBadgeSvgWithColor } from "@app/util/badge/getSvgForBadge";
import { formatDate } from "@app/util/formatters";
import { parseApiDate } from "@app/util/parsers";

import styles from "./MonthViewEvent.module.scss";

interface Props {
  activity: Activity;
}

const MonthViewEvent: React.FC<Props> = ({ activity }) => {
  const isActivityOverdue = getActivityStatus(activity) === ActivityStatus.OVERDUE;

  return (
    <div className={styles.container}>
      <div className={cn(styles.event, { [styles.completed]: activity.completed })}>
        {activity.completed && <FontAwesomeIcon className={styles.completedIcon} icon={faCheck} />}
        {activity.allDay ? "" : <>{formatDate(parseApiDate(activity.startAt!), "p")}&nbsp;</>}
        <span>{activity.name}</span>
      </div>
      {isActivityOverdue && (
        <div className={styles.overdueContainer}>
          {getBadgeImage(getBadgeSvgWithColor(colors.red100), 16)}
        </div>
      )}
    </div>
  );
};

export default MonthViewEvent;
